import * as React from "react";
import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";
import { CircleIcon } from "lucide-react";
import { cn } from "../utils";

function RadioGroup({
  className,
  ...props
}: React.ComponentProps<typeof RadioGroupPrimitive.Root> & {
  readOnly?: boolean;
}) {
  const { readOnly, ...rest } = props;
  return (
    <RadioGroupPrimitive.Root
      data-slot="radio-group"
      data-readonly={readOnly || undefined}
      disabled={rest.disabled || readOnly}
      className={cn("qodo qodo-radio-group grid gap-3 group", className)}
      {...rest}
    />
  );
}

function RadioGroupItem({
  className,
  ...props
}: React.ComponentProps<typeof RadioGroupPrimitive.Item>) {
  return (
    <RadioGroupPrimitive.Item
      data-slot="radio-group-item"
      className={cn(
        "qodo qodo-radio-group-item cursor-pointer border-border-input-neutral-idle bg-fill-input-neutral-idle focus-visible:border-ring focus-visible:ring-ring/50",
        "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
        "aspect-square size-4 shrink-0 rounded-full border shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px]",
        "aria-checked:border-border-input-emphasis-active hover:aria-checked:border-border-input-emphasis-active",
        "group-data-[readonly]:opacity-100 group-data-[readonly]:cursor-default",
        "data-disabled:cursor-not-allowed data-disabled:opacity-50",
        "aria-disabled:cursor-not-allowed aria-disabled:opacity-50",
        "mt-[2px] mr-0",
        className,
      )}
      {...props}
    >
      <RadioGroupPrimitive.Indicator
        data-slot="radio-group-indicator"
        className="relative flex items-center justify-center"
      >
        <CircleIcon className="stroke-transparent fill-icon-input-emphasis-active absolute top-1/2 left-1/2 size-3 -translate-x-1/2 -translate-y-1/2" />
      </RadioGroupPrimitive.Indicator>
    </RadioGroupPrimitive.Item>
  );
}

export { RadioGroup, RadioGroupItem };
